import React from "react";

const About = () => {
  return (
    <div>
      <h3 className="lead container-fluid my-2">
        Github finder application on searching user name, will provide details
        of each user along with top repositories.
      </h3>
    </div>
  );
};

export default About;
